import React from "react";
import { Navigate } from "react-router-dom";
import { useUserAuth } from "../context/userAuthContext";
const ProtectedRoute = ({ children }) => {
  const { user } = useUserAuth();

  if (!user || user === null) {
    return <Navigate to="/" />;
  }
  return children;
};

export default ProtectedRoute;
